import m from "../../es2015/lang/lt_LT";
window.am4lang_lt_LT = m;


//////////////////
// WEBPACK FOOTER
// ./lang/lt_LT.js
// module id = null
// module chunks = 